import { Component, inject } from '@angular/core';
import { MatDialogClose } from "@angular/material/dialog";
import { MatStep, MatStepper, MatStepperNext } from "@angular/material/stepper";
import { NgClass, NgOptimizedImage } from '@angular/common';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { TriggersList } from '../../../variables';
import { DialogService } from '../../../services/dialog.service';

@Component({
    selector: 'app-dialog-first-activate-start-trial',
    imports: [
        MatStepper,
        MatStep,
        MatStepperNext,
        MatDialogClose,
        NgOptimizedImage,
        TranslateModule,
        NgClass
    ],
    templateUrl: './dialog-first-activate-start-trial.component.html',
    styleUrl: './dialog-first-activate-start-trial.component.scss'
})
export class DialogFirstActivateStartTrialComponent {
  private readonly _dialogService: DialogService = inject(DialogService);
  private readonly _translateService: TranslateService = inject(TranslateService);
  triggerList = TriggersList;
  currentLang = this._translateService.currentLang;

  openTriggersDialog() {
    this._dialogService.openAdvancedAmlProtectionTriggersDialog().afterClosed().subscribe(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    });
  }
}
